import { SEO_PAGES_1 } from "@/data/seoPages1";
import { SEO_PAGES_2 } from "@/data/seoPages2";
import { SEO_PAGES_3 } from "@/data/seoPages3";

export const SEO_PAGES = { ...SEO_PAGES_1, ...SEO_PAGES_2, ...SEO_PAGES_3 };
